// extracted by mini-css-extract-plugin
export var carrierTab = "_5n-0";
export var carrierTabActive = "_5n-1 _5n-0";
export var carrierTabInactive = "_5n-2 _5n-0";
export var carrierTabLabel = "_5n-3";
export var carrierTabLabelActive = "_5n-4 _5n-3";
export var carrierTabLabelInactive = "_5n-5 _5n-3";
export var carrierTabPercentage = "_5n-6";
export var carrierTabPercentageActive = "_5n-7 _5n-6";
export var carrierTabPercentageInactive = "_5n-8 _5n-6";
export var carrierTabWinnable = "_5n-9";
export var carrierTabWinnableActive = "_5n-a _5n-9";
export var carrierTabWinnableInactive = "_5n-b _5n-9";
export var comparisonContainer = "_5n-d";
export var missingRateButton = "_5n-n";
export var missingRateButtonActive = "_5n-o _5n-n";
export var missingRateButtonInactive = "_5n-p _5n-n";
export var missingRateButtonLabel = "_5n-q";
export var missingRateButtonLabelActive = "_5n-r _5n-q";
export var missingRateButtonLabelInactive = "_5n-s _5n-q";
export var sidebar = "_5n-c";
export var strategyButton = "_5n-e";
export var strategyButtonActive = "_5n-f _5n-e";
export var strategyButtonDescription = "_5n-k";
export var strategyButtonDescriptionActive = "_5n-l _5n-k";
export var strategyButtonDescriptionInactive = "_5n-m _5n-k";
export var strategyButtonInactive = "_5n-g _5n-e";
export var strategyButtonLabel = "_5n-h";
export var strategyButtonLabelActive = "_5n-i _5n-h";
export var strategyButtonLabelInactive = "_5n-j _5n-h";
export var unitToggleButton = "_5n-t";
export var unitToggleButtonActive = "_5n-u _5n-t";
export var unitToggleButtonInactive = "_5n-v _5n-t";
export var unitToggleButtonLabel = "_5n-w";
export var unitToggleButtonLabelActive = "_5n-x _5n-w";
export var unitToggleButtonLabelInactive = "_5n-y _5n-w";